import * as React from "react";
import { pure } from "recompose";
import { connect } from "react-redux";
import { Dispatch } from "redux";
import { IRootState } from "../../../../store";
import {
  AccountInfoContainer,
  PaymentDetailsContainer,
} from "../../../../containers/booking";
import { useLoginRedirect } from "../../../themed-v2/pages/login/hooks/use-login-redirect";

interface IReduxProps {
  isLoggedIn: boolean;
}

type Props = IReduxProps & { dispatch: Dispatch<any> };

const Checkout: React.FC<Props> = (props) => {
  const { isLoggedIn } = props;
  const loginRedirect = useLoginRedirect();
  if (!isLoggedIn) {
    loginRedirect('/booking');
  }
  return (
    <React.Fragment>
      <AccountInfoContainer />
      <PaymentDetailsContainer />
    </React.Fragment>
  );
};

const mapStateToProps = (state: IRootState): IReduxProps => {
  return {
    isLoggedIn: state.userState.isLogedIn,
  };
};

const store = connect<IReduxProps, {}, {}, IRootState>(mapStateToProps)(
  Checkout,
);

const pureComponent = pure(store);

export { pureComponent as Checkout };
